export class NotificationListLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            name: lang.course[1],
            sno: lang.course[109],
            subject: lang.course[4],
            text: lang.course[153],
            date: lang.course[148],
            notification: lang.course[128],
            action: lang.course[28],
            selectColumns: lang.general[9],
            selectAll: lang.general[10],
            activeColumns: lang.general[11],
            close: lang.general[17],
            exportCsv: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            print: lang.general[16],
            humanResources: lang.general[42],
            view: lang.general[3],
            erase: lang.general[4],
            select_type: lang.course[155],
            import: lang.course[65],
            todownloadtocsv: lang.course[51],
            save: lang.general[0],
            type: lang.course[135],
            description: lang.course[147],
            notes: lang.course[149],
            notificationDetails: lang.course[184],
            requiredField : lang.general[26],
            selectFile : lang.course[47],
            editNotification : lang.course[318],
            choose_file:lang.general[108],
            select_img:lang.general[109],


        }

    }

    lang() {
        return this.variables;
    }

}


export class NotificationGeneralLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            name: lang.course[1],
            sno: lang.course[109],
            subject: lang.course[54],
            text: lang.course[153],
            date: lang.course[148],
            notification: lang.course[128],
            action: lang.course[28],
            selectColumns: lang.general[9],
            selectAll: lang.general[10],
            activeColumns: lang.general[11],
            close: lang.general[17],
            exportCsv: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            print: lang.general[16],
            humanResources: lang.general[42],
            view: lang.general[3],
            erase: lang.general[4],
            requiredField:lang.general[26],
            addNotification:lang.course[266],
            type:lang.course[135],
            description:lang.course[147],
            notes:lang.course[149],
            attachments:lang.course[150],
            save:lang.general[0], 
            select_type:lang.course[155],
            communication:lang.course[186],
            consultation:lang.course[187],
            other:lang.course[188],

        }

    }

    lang() {
        return this.variables;
    }

}
